import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { Category } from "../../../../../api/types/accessTypes";
import type { Fundraising } from "../../../../../api/types/fundraisingTypes";
import type { DetailsPageTab, FundraisingStatusTransition } from "../fundraisingsPageTypes";

interface Props {
  fundraising: Fundraising;
  hasEditPermissions: boolean;
  isContentEditable: boolean;
  fundraisingCategories: Category[];
  isPageDeactivatedOnPortal: boolean;
  onRename: () => void;
  onStatusChange: (statusTransition: FundraisingStatusTransition) => void;
  onConfirmSave: (onSaveConfirmed: () => void) => void;
  onDelete: () => void;
  onTabChange: (tab: DetailsPageTab) => void;
  onUpdated: (fundraising: Fundraising) => void;
  refreshCategories: () => void;
  refreshFundraising: () => void;
}

const FundraisingDetailsPageContext = createContext<Props | undefined>(undefined);

export const FundraisingDetailsPageContextProvider = ({
  fundraising,
  hasEditPermissions,
  isContentEditable,
  fundraisingCategories,
  isPageDeactivatedOnPortal,
  onRename,
  onStatusChange,
  onConfirmSave,
  onDelete,
  onTabChange,
  onUpdated,
  refreshCategories,
  refreshFundraising,
  children,
}: PropsWithChildren<Props>) => (
  <FundraisingDetailsPageContext
    value={{
      fundraising,
      hasEditPermissions,
      isContentEditable,
      fundraisingCategories,
      isPageDeactivatedOnPortal,
      onRename,
      onStatusChange,
      onConfirmSave,
      onDelete,
      onTabChange,
      onUpdated,
      refreshCategories,
      refreshFundraising,
    }}
  >
    {children}
  </FundraisingDetailsPageContext>
);

export default FundraisingDetailsPageContext;
